// Cadre « plein écran » des pages authentifiées sans navigation (lot F14c) : lecteur de contenu ACA-P09 et
// questionnaire de satisfaction ACA-P12, dont les maquettes n'ont ni barre latérale ni barre supérieure. Garde la
// barre d'état réseau, la reconnexion sur place (session expirée) et les notifications toast de l'AppShell.
import { Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useSessionExpired } from '@/app/session';
import { useMe } from '@/app/me';
import { LazyToaster } from '@/design-system/LazyToaster';
import { NetworkStatusBar } from '@/design-system/NetworkStatusBar';

const SessionExpiredOverlay = lazy(() => import('./SessionExpiredOverlay').then((m) => ({ default: m.SessionExpiredOverlay })));

export function FocusShell() {
  const me = useMe();
  const expired = useSessionExpired();
  return (
    <div className="flex h-dvh flex-col bg-bg text-text">
      <NetworkStatusBar />
      <div className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </div>
      {expired && (
        <Suspense fallback={null}>
          <SessionExpiredOverlay me={me} />
        </Suspense>
      )}
      <LazyToaster />
    </div>
  );
}
